// extracted by mini-css-extract-plugin
export default {"expContainer":"Experience_expContainer__U4LS7","heading":"Experience_heading__rt+P5"};